import FilterForm from '../../../components/forms/FilterForm';
import { CanAccess, CrudFilters, HttpError } from '@refinedev/core';
import {
  DeleteButton,
  EditButton,
  ImageField,
  TextField,
  useTable
} from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { Form, Input, Space, Table } from 'antd';
import { ITestimonial } from 'interfaces/testimonials';
import { ListLayout } from 'components/layout/layout/ListLayout';

interface IFilter {
  title: string;
  subtitle: string;
}

export const TestimonialList = () => {
  const { tableProps, searchFormProps } = useTable<
    ITestimonial,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { title, subtitle } = params;

      filters.push(
        {
          field: 'filter[title]',
          operator: 'eq',
          value: title
        },
        {
          field: 'filter[subtitle]',
          operator: 'eq',
          value: subtitle
        }
      );

      return filters;
    }
  });

  return (
    <ListLayout title="Depoimentos">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="title">
          <Input placeholder="Título" className="lg:w-96" />
        </Form.Item>
        <Form.Item name="subtitle">
          <Input placeholder="Subtítulo" className="lg:w-96" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="title"
          key="title"
          title="Título"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="subtitle"
          key="subtitle"
          title="Subtítulo"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={value => <TextField value={value} />}
        />

        <Table.Column<ITestimonial>
          title="Imagem"
          dataIndex="image"
          render={value => <ImageField value={value} width={100} />}
          width="20%"
        />

        <Table.Column<ITestimonial>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          render={(_, record) => {
            return (
              <Space>
                <CanAccess resource="testimonials" action="edit">
                  <EditButton
                    hideText
                    size="small"
                    recordItemId={record.id}
                    icon={<EyeOutlined />}
                  />
                </CanAccess>
                <CanAccess resource="testimonials" action="delete">
                  <DeleteButton
                    size="small"
                    recordItemId={record.id}
                    hideText
                  />
                </CanAccess>
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
